export const TOGGLE_LOADING = 'consent/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'consent/TOGGLE_SUCCESS'
export const UPDATE_CONSENTS = 'consent/UPDATE_CONSENTS'
export const SET_CONSENTS = 'consent/SET_CONSENTS'
export const SET_PERMISSIONS = 'consent/SET_PERMISSIONS'
